import { mediaItems } from '@/mocks/homepage';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">漫画观察</h2>
          <p className="text-sm text-foreground-500">行业动态与深度解读，了解漫画世界的台前幕后</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/80 cursor-pointer transition-colors hover:border-accent-200"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-circle-fill text-xl text-primary-600 group-hover:text-background-50 transition-colors"></i>
                  </span>
                </div>
                <span className="absolute top-3 left-3 bg-accent-100 text-accent-700 text-xs font-medium px-2.5 py-1 rounded-full">
                  {item.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-accent-600 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}